require('./home.less');
require('../../components/tag/index.less');
require('../../app/app');

__webpack_public_path__ = window.pageConfig.assets + '/';

var i18n = require('i18n');
var util = require('../../app/util');
var pagination = require('../../app/pagination');
var pageConfig = window.pageConfig;
var plate = location.pathname.match(/^\/plate\/([^/]+)/);
plate = plate ? plate[1] : pageConfig.defaultPlate;


var wrapper = require('../../app/main.html');
$('body').append(wrapper({
	count: pageConfig.count,
	search: true,
	topicType: [{
		key: 'all',
		value: i18n('all'),
		selected: true
	}, {
		key: 'essence',
		value: i18n('essence.title')
	}].concat(util.toArray(pageConfig.topicType)),
	user: pageConfig.user,
	login: !!pageConfig.user.id
}));

var topicList = require('../../app/topicList.html');




$('.enhancer-tool .tab-list').on('click', '.item', function (e) {
	e.preventDefault();
	
	if ($(this).hasClass('active')) {
		return;
	}	
  $(this).parent().find('.active').removeClass('active');
  $(this).addClass('active');
  var type = $(this).data('type');

  pagination(pageConfig.projectName + '/topic/homeList', topicList, null, null, {
  	refresh: true,
  	type: type
  });
});

//发帖
function addTopic () {
	if (!pageConfig.user.id) {
		return redirect();
	}

	var layer = $('.add-topic-layer');
	if (layer.length) {
    layer.modal('show');
	} else {
		require.ensure(["./addTopicLayer"], function(require) {
			var addTopicLayer = require('./addTopicLayer');
      addTopicLayer( function (res, data) { // 发帖成功后把新帖添加到列表
				var html = topicList({
					data:  [{
						avatar: pageConfig.user.avatar,
						_id: res.id,
						title: data.title,
						replyCount: 0,
						link_url: '/plate/' + plate + '/topic/' + res.id,
						nickname: pageConfig.user.nickname,
						create: util.handleDate(new Date),
						projectName: pageConfig.projectName
					}]
				});

				$('.topic-list').prepend(html);

				if ($('.topic-list').css('display') === 'none') {
					$('.empty-list').hide();
					$('.topic-list').show();
				}

				// 发帖数加1
				var topicNum = $('.statistics-list .statistics-num.my-tp');
				var num = parseInt(topicNum.text(), 10) || 0;
				topicNum.text(num + 1);
			});
			$('.add-topic-layer').modal('show');
    }, 'addTopicLayer');
	}
}
function redirect() {
	var suf = (location.hostname.match(/io|cc|local$/) || ['cc'])[0];
	var suf = location.host.split('.');
	suf = suf[suf.length - 2] + '.' + suf[suf.length - 1]; 
	window.location = '//login.' + suf + '/?callbackUrl=' + location.href;
}
$('body').on('click', '.add-topic', function () { 
	addTopic();
});
$('.add-topic').on('keyup', function (e) {
	if (e.keyCode === 13) {
		addTopic();
	}
});


// 分页
pagination(pageConfig.projectName + '/topic/homeList', topicList);

// 搜索
function search(dom) {
	var val =  dom.val().trim();
	if (val) {
		dom.val('');
		window.location.href = pageConfig.projectName + '/search#key=' + val;
	}
}
$('.enhancer-search').on('keyup', function (e) {
	if (e.keyCode === 13) {
		search($(this));
	}
});
$('.enhancer-search-wrap .search').click(function () {
	search($('.enhancer-search'));
});

if (localStorage.getItem('enhancerNewTopic')) {
	localStorage.setItem('enhancerNewTopic', '');
	$('.add-topic').click();
}







// WEBPACK FOOTER //
// ./src/pages/home/home.js